export default {
    /**
     * 计算类
     */
    Count: {

    },

    /**
     * 表单校验类
     */
    Validate: {
        //姓名  汉字
        checkName(rule, value, callback, text) {
            //姓名
            if (!value) {
                return callback(new Error("请输入姓名"));
            } else {
                setTimeout(() => {
                    var strCheck = /^[\u4e00-\u9fa5]{0,}$/;
                    if (strCheck.test(value) == false) {
                        callback(new Error("请输入正确的格式，只能是汉字！"));
                    } else {
                        callback();
                    }
                }, 500);
            }
        },
        // 年龄
        checkSex(rule, value, callback, text) {
            //姓名
            if (!value) {
                return callback(new Error("请输入年龄"));
            } else {
                setTimeout(() => {
                    var strCheck = /^(1[0-2]\d|\d{1,2})$/;
                    if (strCheck.test(value) == false) {
                        callback(new Error("请输入正确的年龄段！"));
                    } else {
                        callback();
                    }
                }, 500);
            }
        },
        // 邮箱
        checkEmail(rule, value, callback, text) {
            //姓名
            if (!value) {
                return callback(new Error("请输入邮箱"));
            } else {
                setTimeout(() => {
                    var strCheck = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
                    if (strCheck.test(value) == false) {
                        callback(new Error("请输入正确的格式！"));
                    } else {
                        callback();
                    }
                }, 500);
            }
        },
    },

}